import { Button } from '@mantine/core';
import { IconChartBar } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { canGenerateWosIsiReport } from '@/module/WosIsiReport/wosIsiReportAccess';

import { useRoleBoundary } from '@feature/security';

/** Entry point to the WoS ISI report page, shown on the article / abstract lists. */
export function WosIsiReportLinkButton() {
  const { t } = useTranslation();
  const { isRoleOneOf } = useRoleBoundary();

  if (!isRoleOneOf(canGenerateWosIsiReport)) return null;

  return (
    <Button
      size="xs"
      variant="outline"
      leftSection={<IconChartBar size="20px" />}
      component={Link}
      to="/author/wos-isi-report"
    >
      {t('wosIsiReport.analyticsButton')}
    </Button>
  );
}
